import * as createAccessMethod from 'store/actions/accessPoints/access-methods/create/createAccessPointAccessMethod';
import * as openAccessMethod from 'store/actions/accessPoints/access-methods/create/createAccessPointAccessMethodOpen';
import * as deleteAccessMethod from 'store/actions/accessPoints/access-methods/delete/deleteAccessPointAccessMethod';
import * as fetchAccessMethods from 'store/actions/accessPoints/access-methods/fetch/fetchAccessPointAccessMethods';
import * as types from 'store/actions/types';
import * as updateAccessMethod from 'store/actions/accessPoints/access-methods/edit/updateAccessPointAccessMethod';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';
import utils from 'helpers/utils';

function* fetchAccessMethodsAsync({ payload }) {
    try {
        const url = `${ config.getApiBaseUrl() }/access-points-access-methods`;

        const response = yield apiClient.read(url, payload);

        yield put(fetchAccessMethods.fetchAccessPointAccessMethodsSuccess(response));
    } catch (error) {
        yield put(fetchAccessMethods.fetchAccessPointAccessMethodsFailure(error));
    }
}

function* createAccessMethodAsync({ payload }) {
    const {
        onError,
        onSuccess,
        values,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/access-points-access-methods`;

        const response = yield apiClient.create(url, values);

        yield put(createAccessMethod.createAccessPointAccessMethodSuccess(response));

        yield put(showNotification('notifications.access_methods.create.success'));

        onSuccess();
    } catch (error) {
        yield put(createAccessMethod.createAccessPointAccessMethodFailure(error));

        onError();
    }
}

function* createAccessMethodOpenAsync({ payload }) {
    const {
        id,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/access-points-access-methods/${ id }/test`;

        yield apiClient.create(url);

        yield put(openAccessMethod.createAccessPointAccessMethodOpenSuccess());

        yield put(showNotification('notifications.access_methods.open.success'));

    } catch (error) {
        yield put(openAccessMethod.createAccessPointAccessMethodOpenFailure(error));
    }
}

function* updateAccessMethodAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
        values,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/access-points-access-methods/${ id }`;

        const response = yield apiClient.patch(url, values);

        yield put(updateAccessMethod.updateAccessPointAccessMethodSuccess({
            id: id,
            response: response,
        }));

        yield put(showNotification('notifications.access_methods.update.success'));

        if (utils.isFunction(onSuccess)) {
            yield onSuccess();
        }
    } catch (error) {
        yield put(updateAccessMethod.updateAccessPointAccessMethodFailure(error));

        if (utils.isFunction(onError)) {
            yield onError();
        }
    }
}

function* deleteAccessMethodAsync({ payload }) {
    const {
        id,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/access-points-access-methods/${ id }`;

        yield apiClient.delete(url);

        yield put(deleteAccessMethod.deleteAccessPointAccessMethodSuccess(payload));

        yield put(showNotification('notifications.access_methods.delete.success'));

    } catch (error) {
        yield put(deleteAccessMethod.deleteAccessPointAccessMethodFailure(error));
    }
}

function* failureMessage({ error }) {
    const {
        message,
    } = error.response;

    if (!message) {
        return;
    }

    yield put(showNotification(message, 'warning'));
}

export default function* accessPointAccessMethodsSagas() {
    yield [
        takeEvery(types.FETCH_ACCESS_POINTS_ACCESS_METHODS, fetchAccessMethodsAsync),
        takeEvery(types.FETCH_ACCESS_POINTS_ACCESS_METHODS_FAILURE, failureMessage),

        takeEvery(types.CREATE_ACCESS_POINTS_ACCESS_METHOD, createAccessMethodAsync),
        takeEvery(types.CREATE_ACCESS_POINTS_ACCESS_METHOD_FAILURE, failureMessage),

        takeEvery(types.CREATE_ACCESS_POINTS_ACCESS_METHOD_OPEN, createAccessMethodOpenAsync),
        takeEvery(types.CREATE_ACCESS_POINTS_ACCESS_METHOD_OPEN_FAILURE, failureMessage),

        takeEvery(types.UPDATE_ACCESS_POINTS_ACCESS_METHOD, updateAccessMethodAsync),
        takeEvery(types.UPDATE_ACCESS_POINTS_ACCESS_METHOD_FAILURE, failureMessage),

        takeEvery(types.DELETE_ACCESS_POINTS_ACCESS_METHOD, deleteAccessMethodAsync),
        takeEvery(types.DELETE_ACCESS_POINTS_ACCESS_METHOD_FAILURE, failureMessage),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/access-points/accessPointsAccessMethodsSagas.js